<template>
  <b-modal id="deliveries-modal" title="Deliveries" size="lg" ok-only>
    <b-table
        size="sm"
        :items="paginatedDeliveries"
        :fields="fields"
        small
        striped
    >
      <template #cell(timestamp)="data">
        {{ formatDate(data.value) }}
      </template>
      <template #cell(url)="data">
        <b-link :href="data.value" target="_blank">Download</b-link>
      </template>
    </b-table>
    <b-pagination
        v-model="currentPage"
        :total-rows="deliveries.length"
        :per-page="perPage"
        align="center"
        class="mt-3"
    ></b-pagination>
    <div class="text-center mt-3">
      <b-link @click="goToDeliveries">Go to deliveries</b-link>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    deliveries: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        { key: 'type', label: 'Type' },
        { key: 'subType', label: 'Sub Type' },
        { key: 'timestamp', label: 'Date' },
        { key: 'url', label: 'File' }
      ],
      currentPage: 1,
      perPage: 10
    };
  },
  computed: {
    // Пагинация для отображения только части деливерис
    paginatedDeliveries() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.deliveries.slice(start, end);
    }
  },
  methods: {
    // Форматирование даты в удобочитаемый формат
    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleString();
    },
    // Переход к странице с деливерис
    goToDeliveries() {
      this.$bvModal.hide('deliveries-modal');
      this.$router.push('/deliveries');
    }
  }
};
</script>